// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--3c0Al","container":"style-module--container--1Dh_g","title":"style-module--title--3XmAl","list":"style-module--list--2EKHh"};